module.exports = __webpack_public_path__ + "static/img/yeswecan0004.589134a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0004.png
// module id = 570
// module chunks = 1